function isIntegerString(str) {
  // Convert the string to a number
  const num = Number(str);

  // Check if the conversion to number is successful and if the number is an integer
  return Number.isInteger(num) && str.trim() === String(num);
}


class URLSorter {
    constructor(homeDomain, container=null, unique = false) {
        this.homeDomain = homeDomain
        this.homeDomainUrl = new URL(homeDomain);
        this.container = container
        this.unique = unique
        this.homeGroups = { '_others': [] }
        this.otherCodes = []
    }

    isValidURL(string) {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }

  processQRCode(qrCode) {
    if (!this.isValidURL(qrCode)) {
      this.otherCodes.push(qrCode)
      return;
    }

    const url = new URL(qrCode);
    const domain = url.hostname;
    if (domain !== this.homeDomainUrl.hostname) {
      this.otherCodes.push(qrCode)
      return;
    }
    const path = url.pathname.replace(/^\/|\/$/g, ''); // Trim leading/trailing slashes

    const pathParts = path.split('/');
//    console.log("path", path, pathParts)
    if (pathParts.length === 3 && isIntegerString(pathParts[2])) {
      const [_, category, id] = pathParts;
      if (!this.homeGroups[category]) {
        this.homeGroups[category] = [];
      }
      if (! this.unique || ! this.homeGroups[category].some(item => item.id === id))
        this.homeGroups[category].push({url: qrCode, id: id});
    } else {
      this.homeGroups['_others'].push(qrCode);
    }
  }

  /*removeQRCode(qrCode, once=false) {
    this.otherCodes = this.otherCodes.filter(code => code !== qrCode);

    const url = new URL(qrCode);
    const domain = url.hostname;
    if (domain !== this.homeDomain) return

    const path = url.pathname.replace(/^\/|\/$/g, ''); // Trim leading/trailing slashes

    const pathParts = path.split('/');
    if (pathParts.length === 2 && isIntegerString(pathParts[1])) {
      const [category, id] = pathParts;
      if (this.homeGroups[category]) {
        this.homeGroups[category] = this.homeGroups[category].filter(code => code.url !== qrCode);
        if (this.homeGroups[category].length === 0) {
          delete this.homeGroups[category];
        }
      }
    } else {
      this.homeGroups['_others'] = this.homeGroups['_others'].filter(code => code !== qrCode);
    }
  }*/

  removeQRCode(qrCode, once = false) {
    if (once) {
        let index = this.otherCodes.indexOf(qrCode);
        if (index !== -1) {
            this.otherCodes.splice(index, 1);
        }
    } else {
        this.otherCodes = this.otherCodes.filter(code => code !== qrCode);
    }

    const url = new URL(qrCode);
    const domain = url.hostname;
    if (domain !== this.homeDomain) return;

    const path = url.pathname.replace(/^\/|\/$/g, ''); // Trim leading/trailing slashes

    const pathParts = path.split('/');
    if (pathParts.length === 3 && isIntegerString(pathParts[2])) {
        const [_, category, id] = pathParts;
        if (this.homeGroups[category]) {
            if (once) {
                let index = this.homeGroups[category].findIndex(code => code.url === qrCode);
                if (index !== -1) {
                    this.homeGroups[category].splice(index, 1);
                }
            } else {
                this.homeGroups[category] = this.homeGroups[category].filter(code => code.url !== qrCode);
            }
            if (this.homeGroups[category].length === 0) {
                delete this.homeGroups[category];
            }
        }
    } else {
        if (once) {
            let index = this.homeGroups['_others'].indexOf(qrCode);
            if (index !== -1) {
                this.homeGroups['_others'].splice(index, 1);
            }
        } else {
            this.homeGroups['_others'] = this.homeGroups['_others'].filter(code => code !== qrCode);
        }
    }
  }


  getResults() {
    return {
      otherCodes: this.otherCodes,
      homeGroups: this.homeGroups
    };
  }

  renderResults() {
    if (!this.container) {
      console.error("Container not set!")
      return
    }

    const results = this.getResults();
    this.container.innerHTML = '';

    const otherList = document.createElement('ul');
    otherList.innerHTML = '<em>Non-URL QR Codes:</em>';
    results.otherCodes.forEach(code => {
      const li = document.createElement('li');
      li.textContent = code;
      otherList.appendChild(li);
    });

    const homeDiv = document.createElement('div');
    homeDiv.innerHTML = '';

    Object.keys(results.homeGroups).forEach(category => {
      if (results.homeGroups[category].length === 0) return

      let filterURL = null
      if (category !== '_others') {
        const id_list = [... new Set(results.homeGroups[category].map(x => x.id))].join(',')
        filterURL = `/list/${category}?__batched&_url&_all&id__in=${id_list}`
      }

      const filterLink = filterURL ? `<a href="${filterURL}" class="is-italic ml-3"><i class="fa fa-fw fa-link"></i> batch selected list</a>` : ''
      const categoryList = document.createElement('ul');
      categoryList.classList.add('mb-4')
      categoryList.innerHTML = `<span><strong>${category}</strong> ${filterLink}</span>`;
      results.homeGroups[category].forEach(obj => {
        const li = document.createElement('li');
        li.innerHTML = `
<button class="button is-small is-ghost has-text-danger px-1 mr-1" onclick="sorter.removeQRCode('${obj.url}', once=true); sorter.renderResults()">
    <i class="far fa-fw fa-trash-alt"></i>
</button>
<a href='${obj.url}' style="line-height: 200%;">${obj.url}</a>`;
        categoryList.appendChild(li);
      });
      homeDiv.appendChild(categoryList);
    });
    this.container.appendChild(homeDiv);

    if (results.otherCodes.length > 0)
      this.container.appendChild(otherList);
  }
}

export default URLSorter;


/*
// Example usage:
const sorter = new URLSorter();

const qrCodes = [
  "http://example.com/category/123/",
  "http://example.com/othercategory/456/",
  "http://sub.example.com/category/789/",
  "http://example.com/justpath",
  "not_a_url",
  "http://anotherdomain.com/category/111/",
];

qrCodes.forEach(code => sorter.processQRCode(code));
sorter.renderResults();

// Function to add a new QR code
function addQRCode(qrCode) {
  sorter.processQRCode(qrCode);
  sorter.renderResults();
}

// Function to remove a QR code
function removeQRCode(qrCode) {
  sorter.removeQRCode(qrCode);
  sorter.renderResults();
}*/
